<template>
  <div
    id="mainbox"
    style="
      padding: 34px;
      background-color: #f1f4fa;
      height: calc(100vh - 51px);
      box-sizing: border-box;
      overflow: scroll;
    "
  >
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      "
    >
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="margin-bottom: 39px"
      >
        <el-breadcrumb-item
          v-for="(item, key) in breadcrumb"
          :key="key"
          :to="{ name: item.path }"
          >{{ item.name }}</el-breadcrumb-item
        >
      </el-breadcrumb>
      <el-button type="primary" @click="showAddBrandDialog = true"
        >添加品牌</el-button
      >
    </div>
    <div
      style="
        background-color: #fff;
        overflow: hidden;
        padding: 0 36px;
        text-align: left;
      "
    >
      <div style="text-align: left; margin: 18px 0">查询</div>
      <div
        class="formBox"
        style="
          background: #ffffff;
          border: 2px solid #dcdfe6;
          display: inline-block;
        "
      >
        <el-form
          :inline="true"
          style="text-align: left"
          :model="formInline"
          class="demo-form-inline"
        >
          <el-form-item label="品牌名称">
            <el-input
              style="width: 200px"
              v-model="formInline.name"
              placeholder="请输入品牌名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                currentPage = 1;
                getList();
              "
              >查询</el-button
            >
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="id" label="品牌ID"></el-table-column>
          <el-table-column prop="name" label="品牌名称"></el-table-column>
          <el-table-column
            prop="description"
            label="品牌描述"
          ></el-table-column>
          <el-table-column prop="created_user" label="创建人"></el-table-column>
          <el-table-column prop="created_at" label="创建时间"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template #default="scope">
              <el-button
                @click="showEditBrandDialog(scope.row)"
                type="text"
                size="small"
                >编辑</el-button
              >
              <el-button
                @click="handleDelete(scope.row)"
                type="text"
                size="small"
                >删除</el-button
              >
              <el-button
                @click="showAgentList(scope.row)"
                type="text"
                size="small"
                >站点列表</el-button
              >
              <el-button
                @click="showDbConfig(scope.row)"
                type="text"
                size="small"
                >数据库配置</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination
            style="margin: 20px 0"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加品牌弹出层 -->
    <el-dialog title="添加品牌" :visible.sync="showAddBrandDialog" width="30%">
      <el-form :model="newBrand" ref="newBrandForm">
        <el-form-item
          label="品牌名称"
          :label-width="formLabelWidth"
          prop="name"
          :rules="[
            { required: true, message: '请输入品牌名称', trigger: 'blur' },
          ]"
        >
          <el-input v-model="newBrand.name"></el-input>
        </el-form-item>
        <el-form-item
          label="品牌描述"
          :label-width="formLabelWidth"
          prop="description"
          :rules="[
            { required: true, message: '请输入品牌描述', trigger: 'blur' },
          ]"
        >
          <el-input v-model="newBrand.description"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddBrandDialog = false">取消</el-button>
        <el-button type="primary" @click="createBrand">确定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑品牌弹出层 -->
    <el-dialog
      title="编辑品牌"
      :visible.sync="showEditBrandDialogFlag"
      width="30%"
    >
      <el-form :model="editBrand" ref="editBrandForm">
        <el-form-item
          label="品牌名称"
          :label-width="formLabelWidth"
          prop="name"
          :rules="[
            { required: true, message: '请输入品牌名称', trigger: 'blur' },
          ]"
        >
          <el-input v-model="editBrand.name"></el-input>
        </el-form-item>
        <el-form-item
          label="品牌描述"
          :label-width="formLabelWidth"
          prop="description"
          :rules="[
            { required: true, message: '请输入品牌描述', trigger: 'blur' },
          ]"
        >
          <el-input v-model="editBrand.description"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditBrandDialogFlag = false">取消</el-button>
        <el-button type="primary" @click="updateBrand">保存</el-button>
      </div>
    </el-dialog>

    <!-- 品牌数据库配置弹出层 -->
    <el-dialog
      title="品牌数据库配置"
      :visible.sync="showDbConfigDialog"
      width="50%"
    >
      <el-form :model="brandConfig" ref="brandConfigForm">
        <el-form-item
          label="品牌ID"
          :label-width="formLabelWidth"
          prop="brand_id"
        >
          <el-input v-model="brandConfig.brand_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="配置ID" :label-width="formLabelWidth" prop="id">
          <el-input v-model="brandConfig.id" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="数据库名称"
          :label-width="formLabelWidth"
          prop="db_name"
          :rules="[
            { required: true, message: '请输入数据库名称', trigger: 'blur' },
          ]"
        >
          <el-input v-model="brandConfig.db_name"></el-input>
        </el-form-item>
        <el-form-item
          label="数据库地址"
          :label-width="formLabelWidth"
          prop="db_host"
          :rules="[
            { required: true, message: '请输入数据库地址', trigger: 'blur' },
          ]"
        >
          <el-input v-model="brandConfig.db_host"></el-input>
        </el-form-item>
        <el-form-item
          label="数据库用户名"
          :label-width="formLabelWidth"
          prop="db_user"
          :rules="[
            { required: true, message: '请输入数据库用户名', trigger: 'blur' },
          ]"
        >
          <el-input v-model="brandConfig.db_user"></el-input>
        </el-form-item>
        <el-form-item
          label="数据库密码"
          :label-width="formLabelWidth"
          prop="db_pass"
        >
          <el-input v-model="brandConfig.db_pass" type="password"></el-input>
        </el-form-item>
        <el-form-item
          label="缓存过期时间(秒)"
          :label-width="formLabelWidth"
          prop="cache_ttl"
        >
          <el-input v-model="brandConfig.cache_ttl" type="number"></el-input>
        </el-form-item>
        <el-form-item
          label="其他配置信息"
          :label-width="formLabelWidth"
          prop="other_configs"
        >
          <el-input
            v-model="brandConfig.other_configs"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDbConfigDialog = false">取消</el-button>
        <el-button type="primary" @click="saveBrandConfig">保存</el-button>
      </div>
    </el-dialog>

    <!-- 站点列表弹出层 -->
    <el-dialog title="站点列表" :visible.sync="showAgentListDialog" width="50%">
      <div v-if="loadingAgentList" style="text-align: center; margin-top: 20px">
        <el-loading :loading="loadingAgentList" text="Loading..."></el-loading>
      </div>
      <el-table
        v-else
        :data="agentTableData"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column prop="brand_name" label="品牌名称"></el-table-column>
        <el-table-column prop="agent_id" label="站点 ID"></el-table-column>
        <el-table-column prop="agent_name" label="站点名"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAgentListDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BrandList",
  data() {
    return {
      breadcrumb: [{ name: "品牌列表" }],
      tableData: [],
      formInline: { name: "" },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showAddBrandDialog: false,
      showEditBrandDialogFlag: false,
      showAgentListDialog: false,
      showDbConfigDialog: false,
      newBrand: {
        name: "",
        description: "",
      },
      editBrand: {
        id: "",
        name: "",
        description: "",
      },
      brandConfig: {
        id: "",
        brand_id: "",
        db_name: "",
        db_host: "",
        db_user: "",
        db_pass: "",
        cache_ttl: 3600,
        other_configs: "",
      },
      agentTableData: [],
      loadingAgentList: false,
      formLabelWidth: "120px",
    };
  },
  methods: {
    handleSizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getList();
    },
    getList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .get("/api/brand/list", {
          params: {
            page: this.currentPage,
            page_size: this.pageSize,
            name: this.formInline.name,
          },
        })
        .then((response) => {
          loading.close();
          this.tableData = response.data.items;
          this.total = response.data.total;
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$message.error(err.response.data.message);
          }
          loading.close();
        });
    },
    reset() {
      this.currentPage = 1;
      this.formInline = { name: "" };
      this.getList();
    },
    createBrand() {
      this.$refs.newBrandForm.validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/brand/create", this.newBrand)
            .then(() => {
              this.$message({ type: "success", message: "品牌添加成功!" });
              this.showAddBrandDialog = false;
              this.getList();
            })
            .catch((err) => {
              if (err.response && err.response.data) {
                this.$message.error(err.response.data.message);
              }
            });
        }
      });
    },
    showEditBrandDialog(row) {
      this.editBrand = { ...row };
      this.showEditBrandDialogFlag = true;
    },
    updateBrand() {
      this.$refs.editBrandForm.validate((valid) => {
        if (valid) {
          this.$axios
            .put(`/api/brand/update/${this.editBrand.id}`, this.editBrand)
            .then(() => {
              this.$message({ type: "success", message: "品牌更新成功!" });
              this.showEditBrandDialogFlag = false;
              this.getList();
            })
            .catch((err) => {
              if (err.response && err.response.data) {
                this.$message.error(err.response.data.message);
              }
            });
        }
      });
    },
    handleDelete(row) {
      this.$confirm("确定要删除这个品牌吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .delete(`/api/brand/delete/${row.id}`)
            .then(() => {
              this.$message({ type: "success", message: "删除成功!" });
              this.getList();
            })
            .catch((err) => {
              if (err.response && err.response.data) {
                this.$message.error(err.response.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消删除" });
        });
    },
    showAgentList(row) {
      this.agentTableData = [];
      this.loadingAgentList = true;
      this.showAgentListDialog = true;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .get("/api/agent/listall", {
          params: {
            brand_name: row.name,
          },
        })
        .then((response) => {
          this.agentTableData = response.data.data;
          this.loadingAgentList = false;
          loading.close();
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$message.error(err.response.data.message);
          }
          this.loadingAgentList = false;
          loading.close();
        });
    },
    showDbConfig(row) {
      this.showDbConfigDialog = true;
      this.$axios
        .get("/api/brandc/getconfig", {
          params: {
            brand_id: row.id,
          },
        })
        .then((response) => {
          this.brandConfig = response.data;
        })
        .catch((err) => {
          console.log("Initializing empty brandConfig for brand_id:", row.id);
          //console.log("err", err);
          if (err && (err.status === 404 || err.status === 400)) {
            // 如果未找到配置记录，则填充 brand_id，初始化空配置
            this.brandConfig = Object.assign({}, this.brandConfig, {
              id: "",
              brand_id: row.id,
              db_name: "",
              db_host: "",
              db_user: "",
              db_pass: "",
              cache_ttl: 3600,
              other_configs: "",
            });

            this.$nextTick(() => {
              this.showDbConfigDialog = true; // 保证数据已经被更新后再打开弹出层
            });
          } else if (err.response && err.response.data) {
            this.$message.error(err.response.data.message);
          }
        });
    },
    saveBrandConfig() {
      this.$refs.brandConfigForm.validate((valid) => {
        if (valid) {
          // 将 cache_ttl 从字符串转换为整数
          this.brandConfig.cache_ttl = parseInt(this.brandConfig.cache_ttl, 10);
          const request = this.brandConfig.id
            ? this.$axios.put(`/api/brandc/update`, this.brandConfig)
            : this.$axios.post(`/api/brandc/create`, this.brandConfig);

          request
            .then(() => {
              this.$message({
                type: "success",
                message: "品牌数据库配置保存成功!",
              });
              this.showDbConfigDialog = false;
              this.getList();
            })
            .catch((err) => {
              if (err.response && err.response.data) {
                this.$message.error(err.response.data.message);
              }
            });
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style>
body {
  margin: 0;
}
</style>
